const welcome = {
    title: 'به کنسول مدیریت خوش آمدید',
    description: 'کنسول مدیریت یک برنامه وب برای مدیریت Logto بدون نیاز به کدنویسی است. ابتدا یک حساب ایجاد کنید. با این حساب می‌توانید Logto را به‌صورت شخصی یا از طرف شرکت خود مدیریت کنید.',
    create_account: 'ایجاد حساب',
};
export default Object.freeze(welcome);
